import React, { useState, useEffect, useContext } from "react";
import useSWR from "swr";
import TopNav from "../layout/TopNav";
import { fetcher, commentsFetcher } from "../../utils/request";
import CardSwitcher from "../cards/CardSwitcher";
import Modal from "../common/Modal";
import LoginForm from "../layout/LoginForm";
import ShareModal from "../common/ShareModal";
import FeedbackForm from "../layout/FeedbackForm";
import FeedbackSent from "../layout/FeedbackSent";
import constants from "../../config/constants";
import { trackPageView } from '../../utils/adobeAnalytics';
import AppContext from "../AppContext";
import Fragment from '../cards/common/Fragments';
import { useHistory } from "react-router";
import SideNavigationModalLinks from "../layout/SideNavigationModalLinks"
import getEnvEndpoints from "../../utils/endpoints";
import { setPmbok7Link } from "../../utils/helper";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
const PostPage = ({ isAuthenticated, match, hasAccess, hasAccessUntil, isMember, userPermission, userId }) => {
let subStatus="";
  // Adobe Analytics
  const { isFirstRender, setIsFirstRender } = useContext(AppContext);
  useEffect(() => {
    if (!isFirstRender) {
      trackPageView({ eVar4: "post page" });
    } else {
      setIsFirstRender(false);
    }

  }, []);
  useEffect(() => {
 if (hasAccess && hasAccess == true) {
            if (isMember == true) {
                subStatus = "subscribed:pmi_membership"
            }
            else {
                subStatus = "subscribed:stdplus_subscription"
            }
        }
        else {
            subStatus = "Non-subscribed"
        }
    if (isAuthenticated) {
      let loginData = {
        event: 'loggedin',
        eventInfo: 'loggedin',
        user: {
          membershipTier: userPermission?.isMember?.membership,
          membershipStatus: userPermission?.isMember?.isMember == true ? 'active' : 'expired',
          pmiID: userId
        }
      }
      let subscriptionStatus = {
        event: "sd-app-load",
        eventInfo: "sd-app-load",
        sd: {
          renewalDate:hasAccessUntil.split('T')[0],
          subStatus: subStatus,

        }
      }
      pushDatatoAdobeLayer({ loginData, subscriptionStatus, status: isAuthenticated })
    }
  }, []);
  // end Adobe Analytics
  const endpoints = getEnvEndpoints();
  const showPmbok7 = setPmbok7Link(endpoints);
  const history = useHistory();
  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const [shareModal, setShareModal] = useState({ visible: false, post: null });
  const [feedbackModal, setFeedbackModal] = useState({
    visible: false,
    contentKey: "",
    sent: false,
  });
  const [pmbokModal, setPmbokModal] = useState({ visible: false, data: "" });
  const [downloadedContentKeys, setDownloadedContentKeys] = useState([]);

  const { data: post } = useSWR(
    `/api/content/getContentItem?id=${match.params.id}&contentKey=${match.params.contentKey}`,
    fetcher
  );
  const { data: lookup } = useSWR("/api/lookup", fetcher);
  const { data: getplaylistwithlikes } = useSWR(isAuthenticated ? "/api/playlist/getplaylistwithlikes" : [], fetcher);
  const userLikes = getplaylistwithlikes?.userLikes || [];
  const playlists = getplaylistwithlikes?.playlists || null;
  const { data: feedbacks } = useSWR(
    ["/api/Comment/Query", constants.commentTypes.feedback],
    commentsFetcher
  );
  const canProceed = () => {
    if (isAuthenticated) {
      return true;
    }
    setLoginModalVisible(true);
    return false;
  };
  const isPublicPost = post && post.isPublic
  if (canProceed) {
    if (isPublicPost === false && hasAccess === false) {
      history.push({
        pathname: '/',
        search: ``,
      });
    }
  }

  if (post === null || post === '') {
    history.push(`/404`);
    return null;
  }
  const showShareModal = (post) => setShareModal({ visible: true, post });
  const showFeedbackModal = ({ contentKey }) =>
    setFeedbackModal({ ...feedbackModal, visible: true, contentKey });

  const showPmbokModal = (data) => {
    document.querySelector("body").classList.add("overflow-hidden");
    setPmbokModal({ visible: true, data });
  };

  return (
    <>
      <SideNavigationModalLinks showPmbok7Link={showPmbok7} showPmbok6Link={true} />
      {loginModalVisible && (
        <Modal onClose={() => setLoginModalVisible(false)}>
          <LoginForm refresh={true} />
        </Modal>
      )}
      {shareModal.visible && (
        <ShareModal
          post={shareModal.post}
          onClose={() => setShareModal({ visible: false, post: null })}
        />
      )}
      {feedbackModal.visible && (
        <Modal
          onClose={() =>
            setFeedbackModal({
              ...feedbackModal,
              visible: false,
              contentKey: "",
            })
          }
        >
          <FeedbackForm
            contentKey={feedbackModal.contentKey}
            feedbacks={feedbacks}
            onSubmit={() =>
              setFeedbackModal({
                ...feedbackModal,
                visible: false,
                contentKey: "",
                sent: true,
              })
            }
          />
        </Modal>
      )}
      {feedbackModal.sent && (
        <Modal
          onClose={() => setFeedbackModal({ ...feedbackModal, sent: false })}
        >
          <FeedbackSent
            setModalVisible={() =>
              setFeedbackModal({ ...feedbackModal, sent: false })
            }
          />
        </Modal>
      )}
      {pmbokModal.visible && (
        <Modal onClose={() => setPmbokModal({ visible: false, data: "" })} onClickOutside={true}>
          <Fragment data={pmbokModal.data} />
        </Modal>
      )}
      <div className="flex flex-col">
        <TopNav isAuthenticated={isAuthenticated} />
        <div className="container mx-auto px-4 mt-8">
          <div className="overflow-hidden">
            <div className="flex justify-center" style={{ marginTop: "110px" }}>
              <div className="w-full" style={{ maxWidth: "730px" }}>
                <CardSwitcher
                  post={post}
                  userLikes={userLikes}
                  contentKey={match?.params?.contentKey}
                  id={match?.params?.id}
                  showPmbokModal={showPmbokModal}
                  isAuthenticated={isAuthenticated}
                  showShareModal={showShareModal}
                  showFeedbackModal={showFeedbackModal}
                  canProceed={canProceed}
                  fullcard={true}
                  playlists={playlists || []}
                  feedbacks={feedbacks}
                  lookup={lookup}
                  propGroup={{
                    downloadedContentKeys,
                    setDownloadedContentKeys,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PostPage;
